// extracted by css-extract-rspack-plugin
export default {"codeBlockTextArea":"Bfhub","placeholder":"a1vCj","borderRadius":"NGT_n","closeButton":"zDQyh","contentWrapper":"Zdgq9","iconShrink":"BK4nu"};